// import React from "react";
// import { CheckCircle } from "lucide-react";
// import WarehouseImg from "../assets/Header-Images/warehouseImg.png";
// import "../Styles/WhyChooseUs.css";

// const WhyChooseUs = () => {
//   const reasons = [
//     {
//       iconColor: "green",
//       title: "Supporting Farmers",
//       description:
//         "Our products are made to help you increase productivity and profit because they are specific to the soil and climate of India.",
//     },
//     {
//       iconColor: "yellow",
//       title: "Trusted Products",
//       description:
//         "Our Products are created by professionals to make sure that your crop receives the best care.",
//     },
//     {
//       iconColor: "limegreen",
//       title: "Consistent Innovation",
//       description:
//         "Our research team is always coming up with new ideas, to meet the demands.",
//     },
//     {
//       iconColor: "black",
//       title: "Extensive Network",
//       description:
//         "With an extensive network, we ensure prompt delivery of our products to clients across M.P. and Chhattisgarh.",
//     },
//   ];

//   return (
//     <section className="why-choose-us">
//       {/* Left Side - Image */}
//       <div className="image-container">
//         <img src={WarehouseImg} alt="Warehouse" className="warehouse-img" />
//       </div>

//       {/* Right Side - Content */}
//       <div className="content-container">
//         <h2 className="section-title">Why Choose Us</h2>
//         <div className="reasons-list">
//           {reasons.map((item, index) => (
//             <div key={index} className="reason-item">
//               {/* Icon */}
//               <CheckCircle size={28} style={{ color: item.iconColor }} className="reason-icon" />
//               <div>
//                 <h3 className="reason-title">{item.title}</h3>
//                 <p className="reason-description">{item.description}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhyChooseUs;

import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import WarehouseImg from "../assets/Header-Images/godownImg.jpg";
import "../Styles/WhyChooseUs.css";
import frameImg from "../assets/Header-Images/FrameImg.png"
import { useTranslation } from "react-i18next";

const WhyChooseUs = () => {
  const { t } = useTranslation();

  const reasons = t("whyChooseUs.reasons", { returnObjects: true });
 

  return (
    <>
      <section className="why-choose-us">
        {/* Left Side - Image */}
        <div className="image-container">
          <img src={WarehouseImg} alt="Warehouse" className="warehouse-img" />
        </div>

        {/* Right Side - Content */}
        <div className="content-container">
          <h2 className="section-title">{t("whyChooseUs.title")}</h2>
          <div className="reasons-list">
            {reasons.map((item, index) => (
              <div key={index} className="reason-item">
                {/* Icon */}
                <div className="tick-icon">
                  <FaCheckCircle size={28} style={{ color: item.iconColor }} className="reason-icon" />
                </div>
                <div className="reason-para">
                  <h3 className="reason-title">{item.title}</h3>
                  <p className="reason-description">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <div className="frame-img">
        <img src={frameImg} alt="" />
      </div>
    </>
  );
};

export default WhyChooseUs;

